import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import {
  VARIANTS_DOMAIN,
  VARIANTS_KEY,
  VARIANTS_PATH
} from 'modules/variant/redux/state'
import { REDUX_ACTION_PREFIX } from 'modules/redux/constants'
import setReduxAction from 'modules/redux/actions/set'
import logUtil from 'utils/log'

/**
 * @param props
 * @param props.selectedVariantId
 * @returns {(function(*, *): void)|*}
 */
export default function updateSelectedColorVariantIdRawVariantAction ({ selectedVariantId }) {
  return (dispatch) => {
    const key = VARIANTS_KEY.SELECTED_COLOR_VARIANT_ID
    const logPrefix = `selectedVariantId=${selectedVariantId}`

    const path = VARIANTS_PATH[key]
    logUtil('updateSelectedColorVariantIdRawVariantAction').debug(`${logPrefix} update path=${path}`)
    dispatch(
      setReduxAction({
        type: getActionStrReduxUtil(
          REDUX_ACTION_PREFIX.UPDATE,
          VARIANTS_DOMAIN,
          key,
          selectedVariantId
        ),
        payload: {
          path,
          value: selectedVariantId
        }
      })
    )
  }
}
